<template>
  <div class="slider">
    <inline-field-actions :schema="schema"></inline-field-actions>

    <div class="slider__container">
      <div class="slider__el">
        <div ref="slider" :disabled="disabled" :class="{ 'contain-pips': containPips, 'contain-tooltip': containTooltip }"></div>
        <div class="slider__values">
          <span>{{ schema.minvalue }}</span>
          <span>{{ schema.maxvalue }}</span>
        </div>
      </div>
      <input type="text" class="slider__current-value" :value="currentValue" :disabled="true" />
    </div>
  </div>
</template>

<script>
  import { abstractField } from 'vue-form-generator';
  import noUiSlider from 'nouislider';
  import merge from 'deepmerge';

  require('nouislider/distribute/nouislider.min.css');

  export default {
    mixins: [abstractField],

    data() {
      return {
        slider: null,
        currentValue: 0,
      };
    },

    watch: {
      model() {
        if (noUiSlider && this.slider && this.slider.noUiSlider) {
          this.slider.noUiSlider.set(this.value);
        }
      },
    },

    computed: {
      containPips() {
        return (this.schema.noUiSliderOptions && (typeof this.schema.noUiSliderOptions.pips) !== 'undefined');
      },

      containTooltip() {
        return (this.schema.noUiSliderOptions && this.schema.noUiSliderOptions.tooltips);
      },
    },

    methods: {
      getValue(value) {
        if (Array.isArray(value)) {
          return value[1] ? [parseFloat(value[0]), parseFloat(value[1])] : parseFloat(value[0]);
        }
        return parseFloat(value);
      },

      formatValueToModel(val) {
        if (typeof this.slider.noUiSlider !== 'undefined') {
          if (val instanceof Array) {
            return [Number(val[0]), Number(val[1])];
          }
          return Number(val);
        }
        return val;
      },

      getStartValue() {
        if (this.value != null) {
          return this.value;
        }
        if (typeof this.schema.noUiSliderOptions !== 'undefined' && this.schema.noUiSliderOptions.double) {
          return [this.schema.minvalue, this.schema.minvalue];
        }
        return this.schema.minvalue;
      },
    },

    mounted() {
      this.$nextTick(() => {
        if (noUiSlider) {
          this.slider = this.$refs.slider;
          this.currentValue = this.getStartValue();
          noUiSlider.create(this.slider, merge(this.schema.noUiSliderOptions || {}, {
            start: this.getStartValue(),
            step: this.schema.stepSize || 1,
            range: {
              min: this.schema.minvalue || 0,
              max: this.schema.maxvalue || 100,
            },
          }));
          this.slider.noUiSlider.on('change', value => this.value = this.getValue(value));
          this.slider.noUiSlider.on('update', value => this.currentValue = this.getValue(value));
        } else {
          // eslint-disable-next-line no-console, max-len
          console.warn('noUiSlider is missing. Please download from https://github.com/leongersen/noUiSlider and load the script and CSS in the HTML head section!');
        }
      });
    },

    beforeDestroy() {
      if (this.slider) {
        this.slider.noUiSlider.off('change');
      }
    },
  };
</script>
